import { Gender } from "gen/ApiClient";

export const GenderRecord: Record<Gender, string> = {
    Female: 'Vrouw',
    Male: 'Man',
    Unknown: 'X',
}